import { Link } from 'react-router-dom'
import React, { Component } from 'react'
import MediaQuery from 'react-responsive'
import Cookies from 'universal-cookie'
import { textTranslation, shouldTranslateTo } from '../utils/utils'
import { decode } from 'html-entities'

const cookies = new Cookies()

class Footer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      footerData: null,
    }
  }

  componentDidMount() {
    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          this.setState({
            footerData: pageText,
          })
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }
    getPageText('footer', language)
  }

  render() {
    if (!this.state.footerData) {
      return null
    }
    return (
      <footer className="footer-new">
        <div className="container">
          <div className="row px-md-3">
            <LogoBlock translated={this.state.footerData} />
            <MenuBlockOne translated={this.state.footerData} />
            <MenuBlockTwo translated={this.state.footerData} />
            <MenuBlockThree translated={this.state.footerData} />
          </div>
        </div>

        <div className="copyright px-md-3 px-3 px-md-0 mt-4 mt-md-0">
          <div className="container">
            <FooterBar translated={this.state.footerData} />
          </div>
        </div>
      </footer>
    )
  }
}

const LogoBlock = (props) => (
  <div className="col-12 col-lg-6">
    <div className="col-12 pl-md-0 text-center text-lg-left first-col ">
      <div className="pb-5">
        <img
          style={{ cursor: 'pointer' }}
          src="/images/freebird-header-logo-dark.svg"
          alt="Freebird Club"
          onClick={() => {
            window.location.href = '/'
          }}
        />
      </div>
      <div className="col-12 pl-0 text-center text-lg-left logotype d-flex">
        <p
          className="col-12 pl-0 font-open-sans font-weight-400 pb-4 pr-0 font-size-22"
          dangerouslySetInnerHTML={{
            __html: `${props.translated[0]}`,
          }}
        ></p>
      </div>
    </div>
  </div>
)

const MenuBlockOne = (props) => (
  <div className="col-12 col-sm-4 col-lg-2 text-center text-lg-left">
    <ul className="list-unstyled footer-links pb-4">
      <li className="pb-4">
        <Link
          id="lnk-footer-about-us"
          to="/about-us"
          className="font-all-round font-weight-600 font-size-20"
        >
          {decode(props.translated[1])}
        </Link>
      </li>
      <li className="pb-4">
        <Link
          id="lnk-footer-locals"
          to="/search?seeking=locals"
          className="font-all-round font-weight-600 font-size-20"
        >
          {decode(props.translated[3])}
        </Link>
      </li>

      <li className="pb-4">
        <Link
          id="lnk-footer-homestays"
          to="/search?seeking=homestays"
          className="font-all-round font-weight-600 font-size-20"
        >
          {decode(props.translated[2])}
        </Link>
      </li>

      <li className="pb-4">
        <Link
          id="lnk-footer-become-host"
          to="/become-host"
          className="font-all-round font-weight-600 font-size-20"
        >
          {decode(props.translated[15])}
        </Link>
      </li>

      <li className="pb-4">
        <Link
          id="lnk-footer-how-it-works"
          to="/how-it-works"
          className="font-all-round font-weight-600 font-size-20"
        >
          {decode(props.translated[4])}
        </Link>
      </li>
    </ul>
  </div>
)

const MenuBlockTwo = (props) => (
  <div className="col-12 col-sm-4 col-lg-2 text-center text-lg-left">
    <ul className="list-unstyled footer-links pb-4 pb-sm-0">
      <li className="pb-4">
        <Link
          id="lnk-footer-blog"
          to="/blog"
          className="font-all-round font-weight-600 font-size-20"
        >
          {decode(props.translated[5])}
        </Link>
      </li>
      <li className="pb-4">
        <Link
          id="lnk-footer-faq"
          to="/faq"
          className="font-all-round font-weight-600 font-size-20"
        >
          {decode(props.translated[6])}
        </Link>
      </li>
      <li className="pb-4">
        <Link
          id="lnk-footer-contact"
          className="font-all-round font-weight-600 font-size-20"
          to="/contact"
        >
          {decode(props.translated[8])}
        </Link>
      </li>
    </ul>
    <ul className="list-unstyled footer-links pb-0">
      <li className="pb-4">{decode(props.translated[17])}</li>
    </ul>

    <div className="d-flex justify-content-center justify-content-lg-start pb-5">
      <SocialMediaLinks translated={props.translated} />
    </div>
  </div>
)

const handleLogin = () => {
  window.open('/auth0/login', '_self')
}

const MenuBlockThree = (props) => (
  <div className="col-12 col-sm-4 col-lg-2 text-center text-lg-left">
    <ul className="list-unstyled footer-links pb-4">
      <li className="pb-4">
        <Link
          id="lnk-footer-login"
          to="/partners"
          className="font-open-sans font-weight-300 font-size-18"
        >
          {decode(props.translated[18])}
        </Link>
      </li>
      <li className="pb-4">
        <Link
          id="lnk-footer-login"
          to="/homestay-safety-tips"
          className="font-open-sans font-weight-300 font-size-18"
        >
          {decode(props.translated[16])}
        </Link>
      </li>
      <li className="pb-4">
        <Link
          id="lnk-footer-login"
          to=""
          onClick={() => handleLogin()}
          className="font-open-sans font-weight-300 font-size-18"
        >
          {decode(props.translated[13])}
        </Link>
      </li>
      <li className="pb-4">
        <Link
          id="lnk-footer-signup"
          to="/signup"
          className="font-open-sans font-weight-300 font-size-18 green-link"
        >
          {decode(props.translated[14])}
        </Link>
      </li>
    </ul>
  </div>
)

const SocialMediaLinks = (props) => (
  <ul className="social-items list-unstyled d-flex">
    <li>
      <a
        id="lnk-footer-facebook"
        target="_bank"
        title="facebook"
        href="https://www.facebook.com/FreebirdClub/"
      >
        <i className="fab fa-facebook-f fb-icon" />
      </a>
    </li>
    <li>
      <a
        id="lnk-footer-twitter-x"
        target="_bank"
        title="twitter x"
        href="https://twitter.com/thefreebirdclub"
      >
        {/* <i className="fab fa-x-twitter twitt-icon" /> */}
        <img src="/images/x-twitter.svg" />
      </a>
    </li>
    <li>
      <a
        id="lnk-footer-instagram"
        target="_bank"
        title="instagram"
        href="https://www.instagram.com/freebird.club/"
      >
        <i className="fab fa-instagram ins-icon" />
      </a>
    </li>
    <li>
      <a
        id="lnk-footer-linkedin"
        target="_bank"
        title="linkedin"
        href="https://uk.linkedin.com/company/the-freebird-club"
      >
        <i className="fab fa-linkedin ins-icon" />
      </a>
    </li>
  </ul>
)

const FooterBar = (props) => (
  <div className="row">
    <div className="col-12 col-sm-6">
      <p className="font-open-sans font-size-16 text-center text-sm-left">
        © {new Date().getFullYear()} Freebird Club
      </p>
    </div>
    <div className="col-12 col-sm-6">
      <nav className="navbar navbar-expand-lg navbar-light h-100 text-center text-sm-left justify-content-center justify-content-sm-right">
        <ul className="navbar-nav ml-sm-auto my-auto">
          <li className="nav-item active">
            <a
              id="lnk-footer-privacy"
              className="nav-link mr-0 mr-lg-4"
              href="/privacy-policy"
            >
              {decode(props.translated[9])}
            </a>
          </li>
          <li className="nav-item">
            <a
              id="lnk-footer-cookie"
              className="nav-link mr-0 mr-lg-4"
              href="/cookie-policy"
            >
              {decode(props.translated[19])}
            </a>
          </li>
          <li className="nav-item">
            <a
              id="lnk-footer-terms-of-supply"
              className="nav-link mr-0 mr-lg-4"
              href="terms-of-supply"
            >
              {decode(props.translated[10])}
            </a>
          </li>
          <li className="nav-item">
            <a
              id="lnk-footer-terms-conditions"
              className="nav-link"
              href="terms-conditions"
            >
              {decode(props.translated[11])}
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
)

export default Footer
